import {
  ShopContractStatusEnum,
  ShopContractTypeEnum,
  ShopRegistrationStatusEnum,
} from '../types';

const SHOP_CONTRACT_TYPES_TEXTS = {
  [ShopContractTypeEnum.normal]: '常設店舗',
  [ShopContractTypeEnum.event]: 'イベント店舗',
} as const;

const SHOP_REGISTRATION_STATUS_CONTENTS = {
  [ShopRegistrationStatusEnum['pending-approval']]: {
    text: '承認待ち',
    status: 'warning',
  },
  [ShopContractStatusEnum['in-use']]: { text: '利用中', status: 'success' },
  [ShopContractStatusEnum.suspended]: {
    text: '利用停止中',
    status: 'default',
  },
  [ShopRegistrationStatusEnum.returned]: {
    text: '差戻し',
    status: 'error',
  },
  [ShopRegistrationStatusEnum.withdraw]: {
    text: '取下げ',
    status: 'error',
  },
} as const;

const SHOP_CONTRACT_TYPES_OPTIONS = [
  {
    label: SHOP_CONTRACT_TYPES_TEXTS.normal,
    value: ShopContractTypeEnum.normal,
    description: '継続的にプリンターを利用して運営する場合',
  },
  {
    label: SHOP_CONTRACT_TYPES_TEXTS.event,
    value: ShopContractTypeEnum.event,
    description: '特定期間のみ運営する場合',
  },
];

const SHOP_CONTRACT_STATUS_OPTIONS = [
  {
    label: SHOP_REGISTRATION_STATUS_CONTENTS['in-use'].text,
    value: ShopContractStatusEnum['in-use'],
  },
  {
    label: SHOP_REGISTRATION_STATUS_CONTENTS.suspended.text,
    value: ShopContractStatusEnum.suspended,
  },
] as const;

const SHOP_REGISTRATION_STATUS_OPTIONS = [
  {
    label: SHOP_REGISTRATION_STATUS_CONTENTS['pending-approval'].text,
    value: ShopRegistrationStatusEnum['pending-approval'],
  },
  {
    label: SHOP_REGISTRATION_STATUS_CONTENTS.returned.text,
    value: ShopRegistrationStatusEnum.returned,
  },
  {
    label: SHOP_REGISTRATION_STATUS_CONTENTS.temporary.text,
    value: ShopRegistrationStatusEnum.withdraw,
  },
] as const;

const SHOP_ADDITIONAL_INFO_FROM_9_TO_13 = [
  { id: 'NOF-9', name: '開業店舗の郵便番号', value: '' },
  { id: 'NOF-10', name: '住所', value: '' },
  { id: 'NOF-11', name: '会社・店舗名', value: '' },
  { id: 'NOF-12', name: '担当者名', value: '' },
  { id: 'NOF-13', name: '担当者電話番号', value: '' },
];

const SHOP_ADDITIONAL_INFO_8 = [
  { id: 'NOF-8', name: 'インボイス制度の登録', value: '有' },
];

const SHOP_ADDITIONAL_INFO_NAME = {
  info8: 'additional_info_8',
  infoFrom3To7: 'additional_info_3_to_7',
  infoFrom9To13: 'additional_info_9_to_13',
} as const;

export {
  SHOP_ADDITIONAL_INFO_8,
  SHOP_ADDITIONAL_INFO_FROM_9_TO_13,
  SHOP_ADDITIONAL_INFO_NAME,
  SHOP_CONTRACT_STATUS_OPTIONS,
  SHOP_CONTRACT_TYPES_OPTIONS,
  SHOP_CONTRACT_TYPES_TEXTS,
  SHOP_REGISTRATION_STATUS_CONTENTS,
  SHOP_REGISTRATION_STATUS_OPTIONS,
};
